import { CalendarDate, getDayOfWeek, getLocalTimeZone } from "@internationalized/date";

/**
 * Misc utility methods for the scheduler component
 */
export default class InspectionTypeScheduleCalendarUtils {
  /**
   * Gets the text displayed for the calendar week controls.
   *
   * @param date a date in the current week
   * @returns
   */
  static getWeekControlsText(date: CalendarDate): string {
    const weekdays = this.getWeekDays(date);

    const year = date.year;

    const firstDayWeek = weekdays[0];
    const firstDayMonth = firstDayWeek.month;
    const lastDayWeek = weekdays[6];
    const lastDayMonth = lastDayWeek.month;

    if (firstDayMonth !== lastDayMonth) {
      const shortFirst = new Date(firstDayWeek.toString()).toLocaleDateString("en-US", { month: "short" });
      const shortLast = new Date(lastDayWeek.toString()).toLocaleDateString("en-US", { month: "short" });
      return `${shortFirst}-${shortLast} ${year}`;
    }

    return `${new Date(date.toString()).toLocaleDateString("en-US", { month: "long" })} ${year}`;
  }

  /**
   * Gets the header text for each of the days of the week on the scheduler. Just the
   * abbreviation of the week-day followed by the date of the month. So like "Sun 24"
   *
   * @param date a Date object
   *
   * @returns the header text for the day of the week on the scheduler
   */
  static getWeekDayHeaderText(date: CalendarDate): string {
    const temp = date.toDate(getLocalTimeZone());
    const weekDayShort = temp.toLocaleDateString("en-US", { weekday: "short" });
    const dateNumeric = temp.toLocaleDateString("en-US", { day: "numeric" });
    return `${weekDayShort}, ${dateNumeric}`;
  }

  /**
   * Gets all of the days of the week for the week of the given date object.
   *
   * @param date the Date object
   * @returns an array of 7 Date objects
   */
  static getWeekDays(date: CalendarDate): CalendarDate[] {
    const dayOfWeek = getDayOfWeek(date, "en-US");
    const startOfWeek = date.subtract({ days: dayOfWeek });
    return [0, 1, 2, 3, 4, 5, 6].map((dayOfWeek) => {
      return startOfWeek.add({ days: dayOfWeek });
    });
  }

  /**
   * Maps the days of the week for the given Date object to InspectionRequestPreferenceDate objects
   *
   * @param date a Date object
   * @returns an array of InspectionRequestPreferenceDate objects
   */
  static getInspectionDateWeekDays(date: CalendarDate): string[] {
    return this.getWeekDays(date).map((day) => {
      return day.toString();
    });
  }
}
